<div class="linq-dialog">
	<div class="linq-dialog__header">
		<div class="col">
			<h3 class="linq-heading">Select Users</h3>
		</div>
	</div>
	<div class="linq-dialog__content linq-dialog__content_scroll">
		<mat-form-field>
			<mat-label>Search</mat-label>
			<input matInput (keyup)="applySearch($event.target.value)" placeholder="Search" />
			<mat-icon aria-hidden="false" aria-label="Search" matSuffix>search</mat-icon>
		</mat-form-field>
		<sl-table (selectionChanged)="onSelectionChanged($event)" [data]="entityData" [config]="config" [filters]="filters"></sl-table>
	</div>
	<mat-dialog-actions class="linq-dialog__actions">
		<button class="linq-button linq-button--secondary" (click)="cancel()" mat-stroked-button>
			Cancel
		</button>
		<span class="spacer"></span>
		<button class="linq-button linq-button--primary" [disabled]="!selectedUsers.length" (click)="saveSelectedUsers()" mat-flat-button>
			Next
		</button>
	</mat-dialog-actions>
</div>